import * as React from 'react'
import {useContext, useState} from 'react'
import { tagger, ACCENT_TEXT } from '../util/util'
import {api} from '../api/api'
import { useTranslation } from 'react-i18next'
import '../css/modal.css'
import '../css/contactModal.css'
import { AppContext } from '../app'

interface Props {
    show: boolean
    toggle: () => void
}

export const ContactModal = (props: Props) => {
    const tCommon = useTranslation('common').t
    const tContext = useTranslation('contextDistanceCalculator').t
    const tAbout = useTranslation('about').t
    const {t} = useTranslation('contact')

    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [message, setMessage] = useState('')
    const [eName, setEName] = useState<string[]>([])
    const [eEmail, setEEmail] = useState<string[]>([])
    const [eMessage, setEMessage] = useState<string[]>([])
    const [isSuccess, setIsSuccess] = useState(false)
    const [isError, setIsError] = useState(false)
    
    const {utmParameters} = useContext(AppContext)

    const handleCloseModal = () => {
        props.toggle()
        setIsSuccess(false)
        setIsError(false)
    }

    const updateErrors = (name, email, message) => {
        setEName(name)
        setEEmail(email)
        setEMessage(message)
    }

    const sendContactForm = () => {
        updateErrors([], [], [])
        if (name && email && message) {
            const placement = 'context_distance_calculator'
            api.postContactFormData(JSON.stringify({name, email, phone, message, placement, utm: utmParameters || {}}))
                .then(() => {
                    setName('')
                    setEmail('')
                    setPhone('')
                    setMessage('')
                    setIsSuccess(true);
                    (window as any).dataLayer.push({ 'event': 'form-completed', 'location': 'Calculator' })
                })
                .catch(() => {
                    setIsError(true)
                })
        } else {
            updateErrors(
                name ? [] : [tCommon('required field')],
                email ? [] : [tCommon('required field')],
                message ? [] : [tCommon('required field')]
            )
        }
    }

    const renderError = () => (
        <div>
            <div className="modal-upper-block contact-modal">
                <p className="contact-modal__error-title">{tContext('An error occurred')}</p>
                <p className="contact-modal__error-description">{tContext('Something went wrong')}</p>
            </div>
            <div className="modal-footer">
                <button className="btn-modal-continue" onClick={handleCloseModal}>{tCommon('OK')}</button>
            </div>
        </div>
    )

    const renderSuccess = () => (
        <div>
            <div className="modal-upper-block contact-modal">
                <p className="contact-modal__success-title">{tContext('Message Sent')}</p>
                <p className="contact-modal__success-description">{tContext('Thank you for submitting')}</p>
            </div>
            <div className="modal-footer">
                <button className="btn-modal-continue" onClick={handleCloseModal}>{tCommon('OK')}</button>
            </div>
        </div>
    )

    const renderContactForm = () => (
        <div>
            <div className="modal-upper-block contact-modal">
                <p className="contact-modal__description">{tagger(tContext('Fill in the form'), ACCENT_TEXT)}</p>
                <div className="contact-input-container contact-modal__input">
                    <input className={'contact-input small-text' + (eName.length > 0 ? ' error-input' : '')} type="input" name="name" placeholder="&nbsp;" value={name}
                        onChange={e => setName(e.currentTarget.value)} />
                    <span className="contact-input-label">{tAbout('Full name')}</span>
                </div>
                {eName && eName.map(err => <div className="error-small" key={err}>{err}</div>)}
                <div className="contact-input-container contact-modal__input">
                    <input className={'contact-input small-text' + (eEmail.length > 0 ? ' error-input' : '')} type="email" name="email" placeholder="&nbsp;" value={email}
                        onChange={e => setEmail(e.currentTarget.value)} />
                    <span className="contact-input-label">{tAbout('Email address')}</span>
                </div>
                {eEmail && eEmail.map(err => <div className="error-small" key={err}>{err}</div>)}
                <div className="contact-input-container contact-modal__input">
                    <input className="contact-input small-text" type="input" name="phone" placeholder="&nbsp;" value={phone}
                        onChange={e => setPhone(e.currentTarget.value)} />
                    <span className="contact-input-label">{tAbout('Phone number')}</span>
                </div>
                <div className="contact-input-area-container contact-modal__input">
                    <textarea className={'contact-input contact-textarea small-text' + (eMessage.length > 0 ? ' error-input' : '')}
                        name="contactMessage" placeholder="&nbsp;" value={message}
                        onChange={e => setMessage(e.currentTarget.value)} />
                    <span className="contact-input-label">{t('Message')}</span>
                </div>
                {eMessage && eMessage.map(err => <div className="error-small" key={err}>{err}</div>)}
            </div>
            <div className="modal-footer">
                <button className="btn-modal-continue" onClick={sendContactForm}>{tCommon('Send')}</button>
            </div>
        </div>
    )

    return (
        <div className={'modal' + (props.show ? ' modal-show' : ' modal-hide')} >
            <div className="modal-card">
                <div className="close-modal-btn" onClick={handleCloseModal}/>
                { isError ? renderError() : isSuccess ? renderSuccess() : renderContactForm()}
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/contactModal.tsx